import "regenerator-runtime/runtime"
import React, { useRef, useState, useEffect, ChangeEvent } from "react"
import axios from "axios"
import * as utf8 from "utf8"
import { v4 as uuid } from "uuid"
import UniversalCookie from "universal-cookie"
import Lottie from "react-lottie-player"
import { createClient } from "graphql-ws"
import { useSubscription, gql } from "@apollo/client"
import { Button } from "primereact/button"
import { ScrollTop } from "primereact/scrolltop"
import { InputTextarea } from "primereact/inputtextarea"
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition"
// this data is coming from a constants file
import {
  TIM_AI_CHAT_ASSISTANT_NAME,
  TIM_AI_WELCOME_MSG,
  VAN_AI_CHAT_ASSISTANT_NAME,
  VAN_AI_WELCOME_MSG,
  organizationName,
  selectedAIModel,
  userEmailId,
  userId,
  userName,
} from "../../constants/constants.const"
import { useAppContext } from "../../context/appContext"
import { Message } from "../../context/interfacesAndTypes"
import CopilotNotification from "./CopilotNotification/CopilotNotification"
import ChatMessages, { ChatMessageContent } from "./ChatMessages/ChatMessages"
// import AIhead from "./../../images/Smile-Emoji.png"
// import AIhead from "./../../images/AI.svg"
import AIhead from "./../../images/Chat icon_ inner pages.svg"
import Mic from "./../../images/Mic.svg"
import Send from "./../../images/Send.svg"
import errorIcon from "./../../images/Error.svg"
import loadingDotsAnimation from "../../animations/loadingDotsAnimation.json"

import "./ChatComponent.css"
import "./CopilotNotification/CopilotNotification.css"

const NewChatComponent = (props: any) => {
  const cookies = new UniversalCookie()

  const { transcript, listening } = useSpeechRecognition()

  const {
    state,
    setChatAiName,
    setSendHomepageChatMessage,
    setHomepageMessage,
  } = useAppContext()

  const [messages, setMessages] = useState<Message[]>([])
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  // const [userInput, setUserInput] = useState<string>(
  //   props.userMessage ? props.userMessage : ""
  // )
  const [userInput, setUserInput] = useState<string>(
    state.homepageMessage || ""
  )
  const [messageLoading, setMessageLoading] = useState<boolean>(false)
  const [showWaitingMessage, setShowWaitingMessage] = useState<boolean>(false)
  const [isMobile, setIsMobile] = useState<boolean>(false)
  const [speechRecognitionSupported, setSpeechRecognitionSupported] =
    useState<boolean>(false)
  const [isStreaming, setIsStreaming] = useState<boolean>(false)
  const [chatSettings, setChatSettings] = useState<any>({})
  const [replyMessage, setReplyMessage] = useState("")
  // for Copilot notification
  const [lowConfidenceScoreIds, setLowConfidenceScoreIds] = useState<string[]>(
    []
  )
  const [expertAnswerIds, setExpertAnswerIds] = useState<string[]>([])
  const [sessionId, setSessionId] = useState("")
  const [ids, setIds] = useState<string[]>([])
  const [copilotNotifications, setCopilotNotifications] = useState<any>([])

  const [isChatHistoryLoaded, setIsChatHistoryLoaded] = useState(false)

  const [openAccordions, setOpenAccordions] = useState([])
  const [selectedHeaderMessage, setSelectedHeaderMessage] = useState()
  const [expandedResponses, setExpandedResponses] = useState([])
  const [selectedResponseData, setSelectedResponseData] = useState("")

  // const [workflowStreaming, setWorkflowStreaming] = useState<boolean>(true)
  // console.log("selectedResponseData", selectedResponseData)
  const toggleExpandedResponse = index => {
    setExpandedResponses((prev: any) =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    )
  }

  const chatInputRef = useRef<HTMLTextAreaElement>(null)
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const lastPairRef = useRef<HTMLDivElement>(null)
  const messageRefs = useRef<(HTMLDivElement | null)[]>([])

  const chatAssistantName =
    state.chatAiName === "vanai"
      ? VAN_AI_CHAT_ASSISTANT_NAME
      : TIM_AI_CHAT_ASSISTANT_NAME

  const welcomeMsg =
    state.chatAiName === "vanai" ? VAN_AI_WELCOME_MSG : TIM_AI_WELCOME_MSG

  let guestSessionId = cookies.get(`${chatAssistantName}_guestSessionId`)

  if (!guestSessionId) {
    guestSessionId = `techolution-${chatAssistantName}-${uuid()}`
    cookies.set(`${chatAssistantName}_guestSessionId`, guestSessionId, {
      path: "/",
      maxAge: 6 * 60 * 60, // Set cookie to expire in 6 hours
    })
  }

  try {
    const NOTIFICATION_SUBSCRIPTION = gql`
      subscription OnNotification(
        $notificationSessionId: String!
        $name: String!
      ) {
        notification(
          notificationSessionId: $notificationSessionId
          name: $name
        ) {
          name
          isCopilot
          requestId
          message
        }
      }
    `

    useSubscription(NOTIFICATION_SUBSCRIPTION, {
      variables: {
        notificationSessionId: sessionId,
        name: chatAssistantName,
      },
      onData: ({ data: { data } }) => {
        if (
          !ids.includes(data?.notification?.requestId) &&
          data?.notification?.name === chatAssistantName &&
          doesRequestIdExist(data?.notification?.requestId)
        ) {
          setIds([...ids, data?.notification?.requestId])
          setCopilotNotifications([
            ...copilotNotifications,
            {
              requestId: data?.notification?.requestId,
              answer: data?.notification?.message,
              name: data?.notification?.name,
            },
          ])
          ids.push(data?.notification?.requestId)
        }
      },
    })
  } catch (error) {
    console.error(error)
  }

  useEffect(() => {
    // setSessionId(`chat-session-${uuid()}`)

    if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
      setSpeechRecognitionSupported(true)
    }
  }, [])

  useEffect(() => {
    resizeCallback()

    function resizeCallback() {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      if (width < 1050) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    window.addEventListener("resize", resizeCallback)
    return () => window.removeEventListener("resize", resizeCallback)
  }, [])
  // console.log("testing history:", messages)

  useEffect(() => {
    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0

    if (!isTouchDevice) {
      !isMobile && chatInputRef?.current?.focus()
    }
  }, [messages])

  useEffect(() => {
    if (listening) {
      setUserInput(transcript)
    }
  }, [transcript, listening])

  const getDate = (date: any) => {
    const dateFormat = new Date(date)
    const options: any = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }
    const formattedDate = new Date(dateFormat).toLocaleDateString(
      "en-US",
      options
    )

    // Split the formatted date into day, month, and year parts
    const [month, day] = formattedDate.split(" ")
    return day
  }

  const formatMessageDate = (date: any) => {
    const dateFormat = new Date(date)
    const options: any = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }
    const formattedDate = new Date(dateFormat).toLocaleDateString(
      "en-US",
      options
    )

    // Split the formatted date into day, month, and year parts
    const [month, day, year] = formattedDate.split(" ")

    const hours = String(dateFormat.getHours()).padStart(2, "0")
    const minutes = String(dateFormat.getMinutes()).padStart(2, "0")
    // const seconds = String(dateFormat.getSeconds()).padStart(2, '0');

    // Return the formatted date with uppercase month abbreviation and desired format
    return `${day.split(",")[0]} ${month}`
  }

  const isYesterday = (date: any) => {
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    const dt = new Date(date)

    return (
      dt.getDate() === yesterday.getDate() &&
      dt.getMonth() === yesterday.getMonth() &&
      dt.getFullYear() === yesterday.getFullYear()
    )
  }

  const addDateDividerToMessages = (data: any) => {
    const today = getDate(Date.now())
    let previousDay: any

    const msgs = data.map((message: any, index: number) => {
      let text = ""
      let formattedMessage: any

      // Calculate the display text for the message date
      if (getDate(message.time) === today) {
        text = `Today, ${formatMessageDate(new Date(message.time))}`
      } else if (isYesterday(new Date(message.time))) {
        text = `Yesterday, ${formatMessageDate(new Date(message.time))}`
      } else {
        text = formatMessageDate(new Date(message.time))
      }

      // Determine if the message needs the `messageDay` property
      if (index === 0) {
        formattedMessage = { ...message, messageDay: text }
      } else if (getDate(message.time) === getDate(previousDay)) {
        formattedMessage = message
      } else {
        formattedMessage = { ...message, messageDay: text }
      }

      // Update previousDay to the current message time
      previousDay = new Date(message.time)

      // Return the message with the `time` property formatted as a Date object
      return {
        ...formattedMessage,
        time: new Date(formattedMessage.time),
      }
    })

    setMessages(msgs)
  }

  // function to get chat history
  const getChatHistory = () => {
    try {
      setMessageLoading(true)

      axios
        .get(
          `${process.env.GATSBY_EGPT_API_URL}/api/chat/history?name=${chatAssistantName}&organizationName=${organizationName}&guestSessionId=${guestSessionId}`
        )
        .then(response => {
          const data = response.data

          if (data.length > 0) {
            setMessageLoading(false)
            addDateDividerToMessages(data)
            setTimeout(() => {
              scrollToBottom()
            }, 1000)
          } else {
            setMessageLoading(false)
            // setShowWelcomeMessage(true);
            setMessages([])
          }
          setIsChatHistoryLoaded(true)
        })
        .catch(error => {
          setMessageLoading(false)
          console.error(error)
        })
    } catch (error) {
      setMessageLoading(false)
      console.error(error)
    }
  }

  //  reset chat window data
  const resetChat = () => {
    try {
      axios
        .get(
          `${process.env.GATSBY_EGPT_API_URL}/api/chat/resetHistory?name=${chatAssistantName}&organizationName=${organizationName}&guestSessionId=${guestSessionId}`
        )
        .then(() => {
          setMessages([])
          setMessageLoading(false)
          setUserInput("")
        })
        .catch(error => {
          console.error(error)
        })
    } catch (error) {
      setMessageLoading(false)
      console.error(error)
    }
  }

  // getting chat settings and confidence score threshold values (it includes 2 api calls and combine their results in one state)
  const getChatSettings = () => {
    const fetchChatSettings = () =>
      axios.request({
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.GATSBY_EGPT_API_URL}/api/chatbot/getChatSettings?name=${chatAssistantName}&organizationName=${organizationName}`,
        headers: {},
      })

    const fetchThresholdValue = () =>
      axios.request({
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.GATSBY_EGPT_API_URL}/api/chatbot/getConfidenceScoreThreshold?name=${chatAssistantName}&organizationName=${organizationName}`,
        headers: {},
      })

    Promise.all([fetchChatSettings(), fetchThresholdValue()])
      .then(([chatSettingsResponse, thresholdResponse]) => {
        const chatSettings = chatSettingsResponse?.data?.chatSettings
        const confidenceScoreThreshold =
          thresholdResponse?.data?.confidenceScoreThreshold
        // console.log(thresholdResponse?.data?.confidenceScoreThreshold)

        if (chatSettings) {
          const combinedSettings = {
            ...chatSettings,
            confidenceScoreThreshold, // Add the threshold value to the chat settings
          }

          setChatSettings(combinedSettings)
        }
      })
      .catch(error => {
        console.error(error)
        setErrorMessage(
          "Oops! We’re having trouble loading your chat settings. Allow us a moment to sort this out. Please try again in a bit."
        )
      })
  }

  // triming the message to show characters upto a length (maxLength)
  const truncateMessage = (message: any, maxLength: any) => {
    if (message.length > maxLength) {
      return message.slice(0, maxLength) + "..."
    }
    return message
  }

  const replaceAsteriskInAnchor = (inputString: string): string => {
    const regex = /<a [^>]*>.*?<\/a>/g
    const replacedString = inputString.replace(regex, match => {
      return match.replace(/\*/g, "&ast;")
    })
    return replacedString
  }

  const extractWaitMessage = (inputString: string) => {
    const prefix = "WaitMessage: "
    const startIndex = inputString.indexOf(prefix)

    if (startIndex !== -1) {
      const extractedString = inputString.substring(startIndex + prefix.length)
      return extractedString.replace(new RegExp(prefix, "g"), "")
    } else {
      return ""
    }
  }

  const encodeParam = (param: any): string => {
    return utf8.encode(param)
  }

  const isOnlySpaces = (input: string): boolean => {
    return input.trim() === ""
  }

  const handleInputChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    setUserInput(event.target.value)
  }

  // pressing the enter key
  const handleKeyDown = (event: any) => {
    if (!isOnlySpaces(userInput) && event.key === "Enter") {
      const requestId = `requestId-${uuid()}`
      const userQuestionTime = new Date()
      // scrollToBottom()
      scrollToLastPair()

      if (chatSettings.isStreamResponseOn) {
        handleStreamSend(userInput, requestId, userQuestionTime)
      } else {
        sendMessage(userInput, requestId, userQuestionTime)
      }
    }
  }

  // normal receiving of messages
  const sendMessage = (
    query: string,
    requestId: string,
    userQuestionTime?: any
  ) => {
    if (!query.trim()) return

    scrollToLastPair()
    chatInputRef.current?.blur()

    setMessageLoading(true)
    //@ts-ignore
    setMessages([...messages, { role: "user", content: query }])
    setUserInput("")

    try {
      axios
        .post(
          `${process.env.GATSBY_EGPT_API_URL}/api/chat/streamResponsePost`,
          {
            name: encodeParam(chatAssistantName),
            organizationName: encodeParam(organizationName),
            aiModel: encodeParam(selectedAIModel),
            prompt: encodeParam(query),
            userName: encodeParam(userName),
            userEmailId: encodeParam(userEmailId),
            userId: encodeParam(userId),
            requestId: encodeParam(requestId),
            guestSessionId: encodeParam(guestSessionId),
          },
          {
            withCredentials: true,
          }
        )
        .then(() => {
          try {
            const encodedParams: Record<string, string> = {
              name: encodeParam(chatAssistantName),
              organizationName: encodeParam(organizationName),
              aiModel: encodeParam(selectedAIModel),
              userName: encodeParam(userName),
              userEmailId: encodeParam(userEmailId),
              userId: encodeParam(userId),
              requestId: encodeParam(requestId),
              guestSessionId: encodeParam(guestSessionId),
            }
            const urlParams = new URLSearchParams(encodedParams)
            const eventSource = new EventSource(
              `${
                process.env.GATSBY_EGPT_API_URL
              }/api/chat/streamResponseGet?${urlParams.toString()}`,
              { withCredentials: true }
            )

            let streamedresponse = { role: "assistant", content: "" }

            eventSource.onmessage = event => {
              if (event.data === "[DONE]") {
                eventSource.close()
              } else if (event.data.includes("WaitMessage: ")) {
                const data = JSON.parse(event.data)
                if (data?.choices[0]?.delta?.content) {
                  setMessageLoading(false)
                  setShowWaitingMessage(true) // Set showWaitingMessage to true when a waiting message is received
                  streamedresponse.content = extractWaitMessage(
                    data?.choices[0].delta.content + "\n\n"
                  )
                  //@ts-ignore
                  setMessages([
                    ...messages,
                    { role: "user", content: query, time: userQuestionTime },
                    streamedresponse,
                  ])
                  scrollToBottom()
                }
              } else {
                const data = JSON.parse(event.data)
                if (data?.choices[0]?.delta?.content) {
                  setMessageLoading(false)
                  setShowWaitingMessage(false) // Set showWaitingMessage to false when waiting message is finished loading
                  streamedresponse.content = replaceAsteriskInAnchor(
                    data?.choices[0].delta.content
                  ).replace(new RegExp("WaitMessage: ", "g"), "")

                  //@ts-ignore
                  setMessages([
                    ...messages,
                    { role: "user", content: query, time: userQuestionTime },
                    streamedresponse,
                  ])
                  scrollToBottom()
                }
              }
            }
          } catch (error) {
            setMessageLoading(false)
            setShowWaitingMessage(false)
            //@ts-ignore
            setMessages([
              ...messages,
              { role: "user", content: query, time: userQuestionTime },
              {
                role: "assistant",
                content:
                  "Error occurred while sending the message. Please try again later.",
              },
            ])
            scrollToBottom()
            console.error(error)
          }
        })
    } catch (error) {
      console.error("Error sending message:", error)
      setMessageLoading(false) // Stop the loading animation
      setShowWaitingMessage(false)
      //@ts-ignore
      setMessages([
        ...messages,
        { role: "user", content: query, time: userQuestionTime },
        {
          role: "assistant",
          content:
            "Error occurred while sending the message. Please try again later.",
        },
      ]) // Add error message to the messages state
      scrollToBottom() // Scroll to bottom to display the error message
    }
  }

  // Streaming of responses
  const handleStreamSend = async (
    query: string,
    requestId: string,
    userQuestionTime?: any
  ) => {
    // setInputQuestion("")
    if (isOnlySpaces(query)) return

    try {
      scrollToLastPair()

      setMessageLoading(true)
      setReplyMessage("")
      // setWaitMessageLoading(false)
      // setMessages([...messages, { role: "user", content: query }])
      //@ts-ignore
      setMessages(prevMessages => [
        ...prevMessages,
        {
          requestId: requestId,
          role: "user",
          content: query,
          time: userQuestionTime,
        },
      ])
      setUserInput("")

      const client = createClient({
        url: process.env.GATSBY_EGPT_WEBSOCKET_URL ?? "",
      })

      ;(async () => {
        const subscription = client.iterate({
          query: `subscription Subscription($sessionId: String!, $name:String!, $organizationName:String!, $aiModel:String!, $prompt:String!, $userName:String!, $userEmailId:String!, $userId:String!, $requestId:String!,$replyMessage:String!,$customPrompt:String,$guestSessionId:String, $notificationSessionId:String,$images:String,$chatPreviewId:String, $testQuestion:String, $testAnswer:String, $testVariants:String) {
            chatStream(sessionId: $sessionId, name:$name, organizationName:$organizationName, aiModel:$aiModel, prompt:$prompt, userName:$userName, userEmailId:$userEmailId, userId:$userId, requestId:$requestId, replyMessage:$replyMessage, customPrompt:$customPrompt, guestSessionId:$guestSessionId, notificationSessionId:$notificationSessionId,images:$images,chatPreviewId:$chatPreviewId, testQuestion:$testQuestion, testAnswer:$testAnswer, testVariants:$testVariants) {
                continueChatResult {
                    isEnd
                    thinking_break
                    is_orchestrator
                    is_agent
                    responded_by
                    header_message
                    confidenceScore
                    requestId
                    replyMessage
                    sessionId
                    explainability_id
                    message {
                        citations {
                            citation_number
                            title
                            url
                            description
                            metadata {
                                page_index
                                display_url
                                display_name
                            }
                            customMetaData
                        }
                        guides_utilized{
                            id
                            similarity_score
                            feedbacks
                            question
                            variants {
                                id
                                scope 
                                variant
                                created_at
                                appliedTagsIL
                                appliedTagsForQ
                                tagMappingInfoQ
                                originalQuestion
                                tagMappingInfoIL
                                isInstantLearningPlus
                                parameterizedQuestion
                                conditions_whentoapply
                                conditions_whennottoapply
                            }
                        }
                        annotations {
                            citations {
                                citation_number
                                title
                                url
                                description
                                metadata {
                                    page_index
                                    display_url
                                    display_name
                                }
                            }
                            text
                        }
                        userFeedbackId
                        citationDisplayType
                        next_query_suggestions {
                            query
                        }
                        response_type
                        content
                        id
                    }
                    resourceId
                    guestSessionId
                }
            }
        }`,
          variables: {
            sessionId: `${organizationName}-${chatAssistantName}-${uuid()}`,
            name: encodeParam(chatAssistantName),
            organizationName: encodeParam(organizationName),
            aiModel: encodeParam(
              Object.values(chatSettings?.selectedModelNames)[0]
            ),
            // prompt: encodeParam(query),
            prompt:
              replyMessage === ""
                ? encodeParam(query)
                : encodeParam(replyMessage + "\n" + query),
            userName: encodeParam(userName),
            userEmailId: encodeParam(userEmailId),
            userId: encodeParam(userId),
            requestId: encodeParam(requestId),
            replyMessage: replyMessage,
            guestSessionId: encodeParam(guestSessionId),
            notificationSessionId: sessionId,
          },
        })

        let event: any
        let accordianMessageArray: any[] = []
        const explainabilityMap = new Map<
          string,
          { responded_by: string; index: number }
        >()
        for await (event of subscription) {
          // console.log(
          //   "header_message:",
          //   event.data.chatStream.continueChatResult.header_message
          // )
          // console.log("eveent:", event)
          // setWorkflowStreaming(event.data.chatStream.continueChatResult.isEnd)

          const getAssistantObj = (event: any, accordianMessageArray: any) => {
            let streamedresponse = {
              role: "assistant",
              content: "",
              id: uuid(),
            }
            //orchestrator is sending message, we initially set it as normal message
            if (
              event.data.chatStream.continueChatResult.thinking_break ===
                false &&
              event.data.chatStream.continueChatResult.is_orchestrator ===
                true &&
              event.data.chatStream.continueChatResult.isEnd === false
            ) {
              streamedresponse.content = replaceAsteriskInAnchor(
                event.data.chatStream.continueChatResult.message.content
              )?.replaceAll("WaitMessage: ", "")
            }
            //orchestrator is sending message and thinking break is there, we add it to accordian
            if (
              event.data.chatStream.continueChatResult.thinking_break ===
                true &&
              event.data.chatStream.continueChatResult.is_orchestrator ===
                true &&
              event.data.chatStream.continueChatResult.isEnd === false
            ) {
              //check for wait message deletion
              streamedresponse.content = ""
              accordianMessageArray.push({
                responsedata:
                  event.data.chatStream.continueChatResult.message.content,
                responseFrom:
                  event.data.chatStream.continueChatResult.responded_by,
                header_message:
                  event.data.chatStream.continueChatResult.header_message,
                finalResponseStatus: false,
                explainability_id:
                  event.data.chatStream.continueChatResult.explainability_id ??
                  "",
                isParallelToolResponse: false,
              })
            }
            //orchestrator replied with the final message, this is the final response, no need for accordian
            if (
              event.data.chatStream.continueChatResult.thinking_break ===
                false &&
              event.data.chatStream.continueChatResult.is_orchestrator ===
                true &&
              event.data.chatStream.continueChatResult.isEnd === true
            ) {
              streamedresponse.content = replaceAsteriskInAnchor(
                event.data.chatStream.continueChatResult.message.content
              )?.replaceAll("WaitMessage: ", "")
            }
            //agent responded it will directly be shown in collapsed form
            if (
              event.data.chatStream.continueChatResult.thinking_break ===
                false &&
              event.data.chatStream.continueChatResult.is_orchestrator ===
                false &&
              event.data.chatStream.continueChatResult.isEnd === false
            ) {
              const continueChatResult =
                event.data.chatStream.continueChatResult
              // Check for explainability_id and responded_by, and update the map
              if (
                continueChatResult.explainability_id &&
                continueChatResult.responded_by
              ) {
                const explainabilityId = continueChatResult.explainability_id
                const respondedBy = continueChatResult.responded_by
                // Only set the value if the map does not already contain the explainabilityId
                if (!explainabilityMap.has(explainabilityId)) {
                  explainabilityMap.set(explainabilityId, {
                    responded_by: respondedBy,
                    index: accordianMessageArray.length,
                  })
                }
              }
              if (
                explainabilityMap.has(
                  event.data.chatStream.continueChatResult.explainability_id
                )
              ) {
                const targetedIndexId = explainabilityMap.get(
                  event.data.chatStream.continueChatResult.explainability_id
                )
                const index = targetedIndexId?.index
                //@ts-ignore
                accordianMessageArray[index] = {
                  responsedata:
                    event.data.chatStream.continueChatResult.message.content,
                  responseFrom:
                    event.data.chatStream.continueChatResult.responded_by,
                  header_message:
                    event.data.chatStream.continueChatResult.header_message,
                  finalResponseStatus: true,
                  explainability_id:
                    event.data.chatStream.continueChatResult
                      .explainability_id ?? "",
                  isParallelToolResponse: true,
                }
              } else {
                accordianMessageArray = [
                  ...accordianMessageArray,
                  {
                    responsedata:
                      event.data.chatStream.continueChatResult.message.content,
                    responseFrom:
                      event.data.chatStream.continueChatResult.responded_by,
                    header_message:
                      event.data.chatStream.continueChatResult.header_message,
                    finalResponseStatus: true,
                    explainability_id:
                      event.data.chatStream.continueChatResult
                        .explainability_id ?? "",
                    isParallelToolResponse: false,
                  },
                ]
              }
            }
            //final response from agent
            if (
              event.data.chatStream.continueChatResult.thinking_break ===
                true &&
              event.data.chatStream.continueChatResult.is_orchestrator ===
                false &&
              event.data.chatStream.continueChatResult.isEnd === false
            ) {
              const continueChatResult =
                event.data.chatStream.continueChatResult
              // Check for explainability_id and responded_by, and update the map
              if (
                continueChatResult.explainability_id &&
                continueChatResult.responded_by
              ) {
                const explainabilityId = continueChatResult.explainability_id
                const respondedBy = continueChatResult.responded_by
                // Only set the value if the map does not already contain the explainabilityId
                if (!explainabilityMap.has(explainabilityId)) {
                  explainabilityMap.set(explainabilityId, {
                    responded_by: respondedBy,
                    index: accordianMessageArray.length,
                  })
                }
              }

              if (
                explainabilityMap.has(
                  event.data.chatStream.continueChatResult.explainability_id
                )
              ) {
                const targetedIndexId = explainabilityMap.get(
                  event.data.chatStream.continueChatResult.explainability_id
                )
                const index = targetedIndexId?.index
                //@ts-ignore
                accordianMessageArray[index] = {
                  responsedata:
                    event.data.chatStream.continueChatResult.message.content,
                  responseFrom:
                    event.data.chatStream.continueChatResult.responded_by,
                  header_message:
                    event.data.chatStream.continueChatResult.header_message,
                  finalResponseStatus: false,
                  explainability_id:
                    event.data.chatStream.continueChatResult
                      .explainability_id ?? "",
                  isParallelToolResponse: true,
                }
              } else {
                accordianMessageArray.push({
                  responsedata:
                    event.data.chatStream.continueChatResult.message.content,
                  responseFrom:
                    event.data.chatStream.continueChatResult.responded_by,
                  header_message:
                    event.data.chatStream.continueChatResult.header_message,
                  finalResponseStatus: false,
                  explainability_id:
                    event.data.chatStream.continueChatResult
                      .explainability_id ?? "",
                  isParallelToolResponse: false,
                })
              }
            }
            const annotations =
              event?.data?.chatStream?.continueChatResult?.message?.annotations
            const userFeedbackId =
              event?.data?.chatStream?.continueChatResult?.message
                ?.userFeedbackId || ""
            let assistantObj = {
              role: "assistant",
              content: streamedresponse.content,
              orchestratorAndAgentsMessages: accordianMessageArray,
              time: new Date(),
              requestId:
                event.data.chatStream.continueChatResult.requestId ?? "",
              citations:
                event.data.chatStream.continueChatResult.message.citations,
              guides_utilized:
                event.data.chatStream.continueChatResult.message
                  .guides_utilized ?? [],
              annotations: annotations,
              resourceId: event.data.chatStream.continueChatResult.resourceId,
              userFeedbackId,
              citationDisplayType:
                event.data.chatStream.continueChatResult.message
                  .citationDisplayType ?? "",
            }
            if (annotations) {
              for (let index = 0; index < annotations?.length; index++) {
                const annotation = annotations[index]
                assistantObj = {
                  ...assistantObj,
                  content: assistantObj?.content?.replace(
                    annotation?.text,
                    annotation?.text + `<sup>${index}</sup>`
                  ),
                }
              }
            }
            return assistantObj
          }

          // console.log(
          //   "thinking:",
          //   event.data.chatStream.continueChatResult.thinking_break,
          //   "orchestrator:",
          //   event.data.chatStream.continueChatResult.is_orchestrator,
          //   "isEnd:",
          //   event.data.chatStream.continueChatResult.isEnd
          // )

          // if (
          //   event?.data?.chatStream?.continueChatResult?.header_message ===
          //     "Response generated" &&
          //   event?.data?.chatStream?.continueChatResult?.is_agent === true
          // )
          // console.log(event?.data?.chatStream?.continueChatResult)

          {
            setIsStreaming(true)
            let streamedresponse = {
              role: "assistant",
              content: "",
              id: uuid(),
            }
            const assistantObject = getAssistantObj(
              event,
              accordianMessageArray
            )

            if (
              event?.data?.chatStream?.continueChatResult?.message?.content?.includes(
                "WaitMessage: "
              )
            ) {
              // console.log(
              //   "content:",
              //   event?.data?.chatStream?.continueChatResult?.message?.content
              // )
              setMessageLoading(false)
              // setWaitMessageLoading(true)
              streamedresponse.content = extractWaitMessage(
                event.data?.chatStream?.continueChatResult?.message?.content +
                  "\n\n"
              )
              //@ts-ignore
              setMessages([
                ...messages,
                {
                  role: "user",
                  content: query,
                  requestId: requestId,
                  replyMessage: replyMessage,
                  time: userQuestionTime,
                },
                streamedresponse,
              ])
            } else {
              // console.log(
              //   "thinking:",
              //   event.data.chatStream.continueChatResult.thinking_break,
              //   "orchestrator:",
              //   event.data.chatStream.continueChatResult.is_orchestrator,
              //   "isEnd:",
              //   event.data.chatStream.continueChatResult.isEnd,
              //   "content:",
              //   event?.data?.chatStream?.continueChatResult?.message?.content
              // )
              setMessageLoading(false)
              // setWaitMessageLoading(false)
              streamedresponse.content = replaceAsteriskInAnchor(
                event?.data?.chatStream?.continueChatResult?.message?.content
              )?.replace(new RegExp("WaitMessage: ", "g"), "")
              //@ts-ignore
              setMessages([
                ...messages,
                {
                  role: "user",
                  content: query,
                  replyMessage: replyMessage,
                  time: userQuestionTime,
                  requestId:
                    event.data.chatStream.continueChatResult.requestId ?? "",
                },
                {
                  role: "assistant",
                  content: event?.data?.chatStream?.continueChatResult
                    ?.is_orchestrator
                    ? streamedresponse?.content
                    : "",
                  time: new Date(),
                  assistantObject,
                  requestId:
                    event.data.chatStream.continueChatResult.requestId ?? "",
                  isEnd: event.data.chatStream.continueChatResult.isEnd
                    ? true
                    : false,
                },
              ])

              if (event?.data?.chatStream?.continueChatResult?.isEnd) {
                // console.log(
                //   event.data.chatStream.continueChatResult.confidenceScore,
                //   chatSettings.confidenceScoreThreshold
                // )
                if (
                  parseInt(
                    event?.data?.chatStream?.continueChatResult?.confidenceScore
                  ) <= parseInt(chatSettings?.confidenceScoreThreshold)
                ) {
                  setLowConfidenceScoreIds([
                    ...lowConfidenceScoreIds,
                    event?.data?.chatStream?.continueChatResult?.requestId,
                  ])
                }
                setIsStreaming(false)
                break
              }
            }
          }
        }
      })()
    } catch (error) {
      console.error("Error:", error)
      setIsStreaming(false)
    }
  }

  // console.log(
  //   "testing:",
  //   messages[messages?.length - 1]?.assistantObject
  //     ?.orchestratorAndAgentsMessages
  // )

  // speech recognition button
  const handleSpeechRecognition = () => {
    if (listening) {
      SpeechRecognition?.stopListening()
    } else {
      SpeechRecognition?.startListening()
    }
  }

  // Copilot notification functions
  const doesRequestIdExist = (requestId: string) => {
    return messages?.some(message => message.requestId === requestId)
  }

  // useEffect(() => {
  //   console.log("lowConfidenceScoreIds: ", lowConfidenceScoreIds)
  //   console.log("copilotNotifications", copilotNotifications)
  //   console.log("ids", ids)
  //   console.log("m:", messages)
  // }, [lowConfidenceScoreIds, ids, copilotNotifications])

  const findAndScrollToMessage = requestId => {
    let messageIndex = -1

    // Find the message in groupedMessages
    groupedMessages?.forEach((messagePair, groupIndex) => {
      messagePair?.forEach(message => {
        if (message?.requestId === requestId && message?.role === "assistant") {
          messageIndex = groupIndex
        }
      })
    })

    if (messageIndex !== -1) {
      scrollToMessage(messageIndex)
    }
  }

  //when user receive updated Response with less than 90% confidance score
  const handleCloseCopilotNotification = async (requestId: string) => {
    // const headers = { Authorization: `Bearer ` }

    const filteredArray = copilotNotifications?.filter((data: any) => {
      return data.requestId !== requestId
    })
    setCopilotNotifications(filteredArray)

    const filteredLowConfidenceScores = lowConfidenceScoreIds?.filter(
      (item: string) => {
        return item !== requestId
      }
    )
    setLowConfidenceScoreIds(filteredLowConfidenceScores)

    try {
      await axios.post(
        `${process.env.GATSBY_EGPT_API_URL}/api/chat/updateAnswerFromCopilot`,
        { requestId: requestId, answer: "", status: "declined" }
        // { headers, withCredentials: true }
      )
    } catch (error) {
      console.error("Error in updating RLEF resource (Copilot): ", error)
    }
  }

  // when user recieve the updated reposne form Copilot and user want to see new updated message
  const handleExpertUpdatedResponseCopilot = async (
    requestId: string,
    expertAnswer: string
  ) => {
    // const headers = { Authorization: `Bearer ` }

    const filteredArray = copilotNotifications?.filter((data: any) => {
      return data.requestId !== requestId
    })
    setCopilotNotifications(filteredArray)
    setMessages(prevMessages =>
      prevMessages.map(message =>
        message.requestId === requestId && message.role === "assistant"
          ? { ...message, content: expertAnswer }
          : message
      )
    )

    const filteredIds = lowConfidenceScoreIds?.filter((id: string) => {
      return id !== requestId
    })
    setLowConfidenceScoreIds(filteredIds)

    findAndScrollToMessage(requestId)

    try {
      await axios.post(
        `${process.env.GATSBY_EGPT_API_URL}/api/chat/updateHistory`,
        {
          name: chatAssistantName,
          organizationName: organizationName,
          messageId: requestId,
          updatedMessage: expertAnswer,
          guestSessionId: guestSessionId,
        },
        { withCredentials: true }
      )
    } catch (error) {
      console.error("Error in updating chat history: ", error)
    }

    try {
      await axios.post(
        `${process.env.GATSBY_EGPT_API_URL}/api/chat/updateAnswerFromCopilot`,
        { requestId: requestId, answer: expertAnswer, status: "accepted" }
        // { headers, withCredentials: true }
      )
    } catch (error) {
      console.error("Error in updating RLEF resource (Copilot): ", error)
    }
  }

  // const handleMinimiseChatbot = () => {
  //   props.setShowChatWindow(false)
  //   window.fullpage_api?.setAllowScrolling(true)
  // }

  // close the chat window
  const handleCloseChatbot = () => {
    props.setShowChatWindow(false)
    setMessages([])
    setChatAiName("timai")

    // window.fullpage_api?.setAllowScrolling(true)
    document.documentElement.style.overflow = "auto"
  }

  // scroll to bottom
  const scrollToBottom = () => {
    const scrollContainer = scrollContainerRef.current
    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: scrollContainer.scrollHeight,
        // behavior: "smooth",
      })
    }
  }

  // scroll to last pair for new scrolling
  const scrollToLastPair = () => {
    lastPairRef.current
      ?.scrollIntoView
      // { behavior: "smooth" }
      ()
  }

  // scroll to particular message after clicking on copilot notification
  const scrollToMessage = (index: number) => {
    if (messageRefs.current[`${index}-${0}`]) {
      messageRefs.current[`${index}-${0}`]
        ?.scrollIntoView
        // {behavior: "smooth"}
        ()
    }
  }

  // grouping of message to form a pair
  const groupMessages = messages => {
    const grouped: any = []
    for (let i = 0; i < messages.length; i += 2) {
      grouped?.push(messages?.slice(i, i + 2))
    }
    return grouped
  }

  const groupedMessages = groupMessages(messages)

  useEffect(() => {
    scrollToLastPair()
  }, [messageLoading, showWaitingMessage])

  // get chat settings and history
  useEffect(() => {
    if (props.showChatWindow) {
      setSessionId(`chat-session-${uuid()}`)

      getChatSettings()
      getChatHistory()
    }
  }, [props.showChatWindow, state.chatAssistantName, guestSessionId])

  useEffect(() => {
    if (
      state.sendHomepageChatMessage &&
      chatSettings.chatInitialMessage &&
      guestSessionId &&
      sessionId &&
      isChatHistoryLoaded &&
      errorMessage === null &&
      !messageLoading &&
      !showWaitingMessage &&
      !isStreaming
    ) {
      // console.log("log chatSettings:", chatSettings)
      // console.log("log message:", state.homepageMessage)
      // console.log("log guestID:", guestSessionId)
      // console.log("log session id:", sessionId)
      // console.log("log isChatloaded:", isChatHistoryLoaded)

      // setTimeout(() => {
      setMessageLoading(true)
      setSendHomepageChatMessage(false)

      const requestId = `requestId-${uuid()}`
      const userQuestionTime = new Date()
      // scrollToBottom()
      scrollToLastPair()

      if (chatSettings.isStreamResponseOn) {
        handleStreamSend(state.homepageMessage, requestId, userQuestionTime)
      } else {
        sendMessage(state.homepageMessage, requestId, userQuestionTime)
      }
      setHomepageMessage("")
      // }, 3000)
    }
  }, [
    chatSettings,
    isChatHistoryLoaded,
    guestSessionId,
    sessionId,
    state.homepageMessage,
  ])

  return (
    <div className={`chat-container `}>
      <div className="chat-header" style={{ zIndex: "100" }}>
        <div className="chat-window-actions">
          {copilotNotifications?.length > 0 && (
            <div className="notifications-container">
              {chatSettings?.isStreamResponseOn &&
                copilotNotifications?.map((data: any, index: number) => {
                  return (
                    <CopilotNotification
                      key={data?.requestId}
                      name={data?.name}
                      expertAnswer={data?.answer}
                      requestId={data?.requestId}
                      handleCloseCopilotNotification={
                        handleCloseCopilotNotification
                      }
                      handleExpertUpdatedResponseCopilot={
                        handleExpertUpdatedResponseCopilot
                      }
                      setExpertAnswerIds={setExpertAnswerIds}
                      expertAnswerIds={expertAnswerIds}
                      index={index}
                    />
                  )
                })}
            </div>
          )}
          <div>
            <Button
              disabled={messages.length === 0 || isStreaming}
              className={
                messages.length === 0 ? "chat-window-refresh-disabled" : ""
              }
              title="refresh chat window"
              icon="pi pi-refresh"
              onClick={() => resetChat()}
              rounded
            />
            {/* 
            <Button
              title="minimise chat window"
              icon="pi pi-minus"
              onClick={() => {
                // handleMinimiseChatbot()
                scrollToMessage(6)
              }}
              rounded
            /> */}
            <Button
              title="close chat window"
              icon="pi pi-times"
              onClick={() => handleCloseChatbot()}
              rounded
            />
          </div>
        </div>
      </div>
      {/* messages container */}
      <div
        className="messages-container scrollable-content"
        id="messages"
        ref={scrollContainerRef}
      >
        {groupedMessages?.length > 0
          ? groupedMessages.map((messagePair, index) => (
              <div
                key={index}
                className={
                  index === groupedMessages.length - 1
                    ? "query-response-pair"
                    : ""
                }
                ref={index === groupedMessages.length - 1 ? lastPairRef : null}
              >
                {/* {console.log("pair", messagePair)} */}
                {messagePair?.map((message, idx) => (
                  <ChatMessages
                    // scrollContainerRef={scrollContainerRef}
                    // lastPairRef={lastPairRef}
                    key={idx}
                    idx={idx}
                    message={message}
                    messageRefs={messageRefs}
                    messageRef={el => {
                      messageRefs.current[`${index}-${idx}`] = el
                    }}
                    isStreaming={isStreaming}
                    openAccordions={openAccordions}
                    setOpenAccordions={setOpenAccordions}
                    setIsStreaming={setIsStreaming}
                    chatSettings={chatSettings}
                    messageLoading={messageLoading}
                    responseHadLessConfidanceScore={lowConfidenceScoreIds?.includes(
                      message?.requestId
                    )}
                    expertAnswerIds={expertAnswerIds}
                    truncateMessage={truncateMessage}
                    setReplyMessage={setReplyMessage}
                  />
                ))}
                {index === groupedMessages.length - 1 &&
                  (messageLoading ||
                    (groupedMessages.length === 0 && !showWaitingMessage)) && (
                    <div
                      className={`message-row ${
                        state.chatAiName === "vanai" ? "vanai" : "timai"
                      } assistant loading-animation`}
                    >
                      {!showWaitingMessage && (
                        <div className="message-sender">
                          <img src={AIhead} alt="AI profile pic" />
                          <span>
                            {state.chatAiName === "vanai" ? "Van AI" : ""}
                          </span>
                        </div>
                      )}
                      <div className={`message chatbot-message`}>
                        {/* <Lottie
                          loop
                          animationData={loadingDotsAnimation}
                          play
                          style={{
                            height: "20px",
                            width: "48px",
                          }}
                        /> */}
                        <p>
                          Thanks for asking! Finding the right answer for you
                          now...
                        </p>
                      </div>
                    </div>
                  )}
              </div>
            ))
          : !messageLoading &&
            !errorMessage &&
            !state.sendHomepageChatMessage && (
              <div
                className={`message-row ${
                  state.chatAiName === "vanai" ? "Van AI" : "timai"
                } assistant`}
              >
                <div className="message-sender">
                  <img src={AIhead} alt="AI profile pic" />
                  <span>{state.chatAiName === "vanai" ? "Van AI" : ""}</span>
                </div>
                <div className={`message chatbot-message`}>
                  <div className="message-text">
                    <ChatMessageContent content={welcomeMsg} />
                  </div>
                </div>
              </div>
            )}
        {errorMessage && (
          <div className="error-container-for-chat message-sender">
            <img src={AIhead} alt="AI profile pic" />
            <p className="error-messsage-for-chat">
              <img src={errorIcon} alt="error" />
              {errorMessage}
            </p>
          </div>
        )}
        <ScrollTop
          target="parent"
          threshold={100}
          icon="pi pi-angle-up text-base"
        />
      </div>
      {/* <div className="loader-container">
          {(isStreaming || (messages.length === 0 && messageLoading)) && (
            <>
              <Lottie
                loop
                animationData={loadingDotsAnimation}
                play
                style={{ height: "70%" }}
              />
              <span>
                {messages.length < 1
                  ? "Getting chat history"
                  : state.chatAiName === "vanai"
                  ? "Van AI is typing"
                  : "Tim AI is typing"}
              </span>
            </>
          )}
        </div> */}

      {/* displaying reply message which will be sent with user message to assistant */}
      {replyMessage !== "" && chatSettings.isStreamResponseOn && (
        <div className="reply-message-container">
          <div className="reply-message-header">
            <span className="">Reply to Techoversity - AI</span>
            <Button icon="pi pi-times" onClick={() => setReplyMessage("")} />
          </div>
          <p className="reply-message">{truncateMessage(replyMessage, 50)}</p>
        </div>
      )}

      {/* input element along with speech-to-text and send button */}
      <div className="input-container">
        <InputTextarea
          title="type message"
          ref={chatInputRef}
          autoResize
          value={userInput}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          rows={5}
          cols={30}
          placeholder="Ask me anything..."
          className="textarea"
          disabled={
            messageLoading ||
            showWaitingMessage ||
            isStreaming ||
            errorMessage !== null
          } // Disable input field while messages are loading or waiting messages are being shown
        />
        {/* <span className="character-count">{userInput?.length} / 2000</span> */}
        {speechRecognitionSupported && (
          <Button
            title="speech to text"
            icon={
              !listening ? <img src={Mic} alt="record-icon" /> : "pi pi-stop"
            }
            onClick={handleSpeechRecognition}
            className={`speech-button ${listening ? "recording" : ""}`}
            rounded
            disabled={
              messageLoading ||
              showWaitingMessage ||
              isStreaming ||
              errorMessage !== null
            } // Disable record button while messages are loading or waiting messages are being shown
          />
        )}
        <Button
          title="send message"
          icon={<img src={Send} alt="send-icon" />}
          onClick={() =>
            chatSettings.isStreamResponseOn
              ? handleStreamSend(userInput, `requestId-${uuid()}`)
              : sendMessage(userInput, `requestId-${uuid()}`)
          }
          className={`send-button ${
            userInput.length === 0 ? "chat-window-refresh-disabled" : ""
          }`}
          // className="send-button"
          rounded
          disabled={
            userInput.length < 1 ||
            messageLoading ||
            showWaitingMessage ||
            isStreaming ||
            errorMessage !== null
          } // Disable send button while messages are loading or waiting messages are being shown
        />
      </div>
    </div>
  )
}

export default NewChatComponent
